/* globals console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    _ = require('lodash'),
    configuration = require('./configuration');

module.exports = function(event) {
    var maxRetries = 10,
        retryInterval = 2999,
        $this = jQuery(event.currentTarget);

    //console.log('Image error: ' + $this.attr('src'));
    // uploaded images are processed by a lambda function on the server.
    // when requested they may not be ready yet!
    if (!$this.data('originalSrc'))
        $this.data('originalSrc', $this.attr('src'));
    if (!$this.data('retries'))
        $this.data('retries', 0);

    $this.addClass('missing')
        .prop('src', configuration.assetBase + 'images/missingImage.svg');

    // TODO: supply a temporary broken image.
    // retry in a few seconds.
    _.delay(_.bind(function() {
        var $this = jQuery(this),
            retries = $this.data('retries') || 0;
        //console.log('...Image error: ' + $this.attr('src'));
        if (retries > maxRetries)
            return;

        $this.removeClass('missing')
            .data('retries', retries + 1)
            .prop('src', $this.data('originalSrc') + '?_=' + (new Date().getMilliseconds()));
    }, event.currentTarget), retryInterval);
};
